import React from "react";
import "./style.sass";

const CIRCLE_SIZE = 96;
const STROKE_WIDTH = 8;
const RADIUS = (CIRCLE_SIZE - STROKE_WIDTH) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

// Color lookup keyed off the tag text itself (sourced from the API's
// own "label" field), not derived from the score anymore.
const getTagColor = (tag) => {
  const normalized = (tag || "").toLowerCase();
  if (normalized === "excellent") return "blue";
  if (normalized === "good") return "green";
  if (normalized === "developing") return "yellow";
  return "purple"; // covers "needs work" and anything unrecognized
};

const MetricCard = ({ label, score, tag, max = 100, showMax = true }) => {
  const color = getTagColor(tag);
  const percent = Math.max(0, Math.min(100, (score / max) * 100));

  return (
    <div className="metric_card">
      <span className="metric_label">{label}</span>
      <div className="metric_score_row">
        <span className="metric_score">{score}</span>
        {showMax && <span className="metric_max">/{max}</span>}
      </div>
      <div className="metric_bar_track">
        <div className={`metric_bar_fill metric_bar_${color}`} style={{ width: `${percent}%` }} />
      </div>
      {tag && <span className={`metric_tag metric_tag_${color}`}>{tag}</span>}
    </div>
  );
};

export const SessionSummaryCard = ({ score, max = 100, title, message, metrics = [], showMax = true }) => {
  const percent = Math.max(0, Math.min(100, (score / max) * 100));
  const dashOffset = CIRCUMFERENCE - (percent / 100) * CIRCUMFERENCE;

  return (
    <div className="session_summary_card">
      <div className="score_circle_card">
        <div className="score_circle_wrap">
          <svg width={CIRCLE_SIZE} height={CIRCLE_SIZE} viewBox={`0 0 ${CIRCLE_SIZE} ${CIRCLE_SIZE}`}>
            <circle
              cx={CIRCLE_SIZE / 2}
              cy={CIRCLE_SIZE / 2}
              r={RADIUS}
              fill="none"
              stroke="#E5E7EB"
              strokeWidth={STROKE_WIDTH}
            />
            <circle
              cx={CIRCLE_SIZE / 2}
              cy={CIRCLE_SIZE / 2}
              r={RADIUS}
              fill="none"
              stroke="#10B981"
              strokeWidth={STROKE_WIDTH}
              strokeLinecap="round"
              strokeDasharray={CIRCUMFERENCE}
              strokeDashoffset={dashOffset}
              transform={`rotate(-90 ${CIRCLE_SIZE / 2} ${CIRCLE_SIZE / 2})`}
            />
          </svg>
          <div className="score_circle_text">
            <span className="score_circle_value">{score}</span>
            <span className="score_circle_caption">Overall</span>
          </div>
        </div>

        <div className="score_feedback">
          <div className="score_feedback_badge">
            <span className="score_feedback_icon">✦</span>
            AI Feedback
          </div>
          {title && <strong className="score_feedback_title">{title}</strong>}
          {message && <p className="score_feedback_message">{message}</p>}
        </div>
      </div>

      {metrics.length > 0 && (
        <div className="metrics_grid">
          {metrics.map((m, i) => (
            <MetricCard key={i} label={m.label} score={m.score} tag={m.tag} max={max} showMax={showMax} />
          ))}
        </div>
      )}
    </div>
  );
};